import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useGetProductsQuery } from '../../../features/api/apiSlice';
import { setAllProducts } from '../../../features/filterSlice/filterSlice';
import ProductCardLoader from '../../ui/loaders/ProductCardLoader';
import Product from './Product';

const Products = () => {
    const [viewCount, setViewCount] = useState(10);
    const { data: products, isLoading, isError, refetch } = useGetProductsQuery(viewCount);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        if (!isLoading && !isError && products?.length > 0) {
            dispatch(setAllProducts(products))
        }
    }, [products, isLoading, isError, dispatch]);

    let content = null;
    if (isLoading) {
        content = (
            <>
                <div className='grid grid-cols-2 md:grid-cols-4 sm:grid-cols-3  gap-7 mt-3'>
                    <ProductCardLoader />
                    <ProductCardLoader />
                    <ProductCardLoader />
                    <ProductCardLoader />
                </div>
            </>
        )
    }
    if (!isLoading && isError) {
        content = <h1>{t('utils.error')}</h1>
    }
    if (!isLoading && !isError && products?.length === 0) {
        content = <h1>{t('utils.notFound')}</h1>
    }
    if (!isLoading && !isError && products?.length > 0) {
        // const jsonPd = JSON.stringify(products.slice(0, 4))
        // localStorage.setItem("allProducts", jsonPd);

        content = (
            <div className='grid grid-cols-2 md:grid-cols-4 sm:grid-cols-3  md:gap-7 gap-2 '>
                {products.map((data, i) => (
                    <Product key={i} product={data} />
                ))}
            </div>
        )
    }
    
    return (
        <div className='container mx-auto md:px-5'>
            {content}
            <div className='text-center py-14 mt-14'>
                <button onClick={() => { setViewCount(products.length + 10); refetch();}} className='w-48 h-12 bg-gray-900 hover:bg-bnd-1 rounded-full text-white font-medium'>{t('home.obPd.morebtn')}</button>
            </div>
        </div>
    );
};

export default Products;